"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventType;
(function (EventType) {
    EventType["ACCESS_COUNT_UPDATED"] = "ACCESS_COUNT_UPDATED";
    EventType["ATTENDANCE_MARKED"] = "ATTENDANCE_MARKED";
    EventType["ILT_SESSION_SESSION_UPDATED"] = "ILT_SESSION_SESSION_UPDATED";
    EventType["CHECKPOINT_REVIEWER_CHANGED"] = "CHECKPOINT_REVIEWER_CHANGED";
    EventType["COMPLETION_STATUS_UPDATED"] = "COMPLETION_STATUS_UPDATED";
    EventType["CONTENT_ASSIGNED"] = "CONTENT_ASSIGNED";
    EventType["CONTENT_DEASSIGNED"] = "CONTENT_DEASSIGNED";
    EventType["DUE_DATE_CHANGED"] = "DUE_DATE_CHANGED";
    EventType["EVALUATED"] = "EVALUATED";
    EventType["FORCED_COMPLETE"] = "FORCED_COMPLETE";
    EventType["GRADED"] = "GRADED";
    EventType["GRADE_REMOVED"] = "GRADE_REMOVED";
    EventType["PROGRESS_MEASURE_UPDATED"] = "PROGRESS_MEASURE_UPDATED";
    EventType["PROGRESS_RESET"] = "PROGRESS_RESET";
    EventType["REVIEWED"] = "REVIEWED";
    EventType["SUBMISSION_REMOVED"] = "SUBMISSION_REMOVED";
    EventType["SUBMISSION_UPDATED"] = "SUBMISSION_UPDATED";
    EventType["SUCESSS_STATUS_UPDATED"] = "SUCESSS_STATUS_UPDATED";
    EventType["SESSION_REGISTERED"] = "SESSION_REGISTERED";
    EventType["SESSION_UNREGISTERED"] = "SESSION_UNREGISTERED";
    EventType["SESSION_WAITLISTED"] = "SESSION_WAITLISTED";
    EventType["TEACHER_FEEDBACK_GIVEN"] = "TEACHER_FEEDBACK_GIVEN";
    EventType["TEACHER_FEEDBACK_REMOVED"] = "TEACHER_FEEDBACK_REMOVED";
    EventType["TIME_SPENT"] = "TIME_SPENT";
    EventType["FLAGGED_QUESTION"] = "FLAGGED_QUESTION";
    EventType["ASSIGNMENT_STARTED_TIMESTAMP"] = "ASSIGNMENT_STARTED_TIMESTAMP";
    EventType["SWITCHED_TO_LATEST_CONTENT"] = "SWITCHED_TO_LATEST_CONTENT";
    EventType["SUBSCRIBE_FOR_ILT_UPDATES"] = "SUBSCRIBE_FOR_ILT_UPDATES";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=index.js.map